import Abstract from "../../../abstract-view/abstract.js";

import {
  CHECKBOX_ANIMATION_DURATION
} from "../../const.js";
export default class Checkbox extends Abstract {
  constructor(element) {
    super();
    this._element = element;
    this._inputElement = this._element.querySelector(`input`);
  }

  hide() {
    this._element.classList.add(`form-label_hidden`);
    setTimeout(() => {
      this._element.style.display = `none`;
    }, CHECKBOX_ANIMATION_DURATION);
  }

  show() {
    this._element.style.opacity = 0;
    this._element.style.display = null;
    this._element.classList.remove(`form-label_hidden`);
    setTimeout(() => {
      this._element.style.opacity = null;
    }, CHECKBOX_ANIMATION_DURATION);
  }

  disable() {
    this._element.classList.add(`form-label_disabled`);
    this._inputElement.disabled = true;
  }

  enable() {
    this._element.classList.remove(`form-label_disabled`);
    this._inputElement.disabled = false;
  }

  check() {
    this._inputElement.checked = true;
  }

  reset() {
    this.enable();
    this._inputElement.checked = false;
  }

  getName() {
    return this._inputElement.name;
  }

  getValue() {
    return this._inputElement.value;
  }

  isChecked() {
    return this._inputElement.checked;
  }
}
